// Single switch to preview the site-wide dark theme variant.
// Flip to false to revert every wired-up component back to the default light theme.
export const IS_DARK_THEME = true;
